/**
 * The site, off the air.
 *
 * Shown for any 503 so that whichever screen she was on gives the same
 * answer, rather than each one inventing its own way of failing.
 */

import { Logo } from './Brand.js';

export function Maintenance({ reason }: { reason?: string | null }) {
  return (
    <div className="page" style={{ textAlign: 'center', paddingTop: '3rem' }}>
      <Logo size={44} />
      <h1 style={{ marginTop: '1rem' }}>Em manutenção</h1>
      <p className="muted">
        O Presente! está fora do ar por alguns minutos. Nada foi perdido: sua
        festa e as respostas continuam aí.
      </p>
      {reason && <p className="muted">{reason}</p>}
      <button className="block" style={{ marginTop: '1rem' }} onClick={() => location.reload()}>
        Tentar de novo
      </button>
    </div>
  );
}
